import React, { useEffect } from 'react'
import Cart from './cart.png'
import './header.css'

const Topbar = () => {
  return (
    <div className="topbar">
      <div className="topbar-inner">
        <ul>
          <li><a href="https://www.bsilab.com/about-us/">ABOUT US</a></li>
          <li><a href="https://www.bsilab.com/contact/">CONTACT</a></li>
          <li><a href="https://www.bsilab.com/my-lists">WISHLISTS</a></li>
          <li><a href="https://www.bsilab.com/my-account">LOGIN</a></li>
          <li><a href="https://www.bsilab.com/cart"><img src={Cart} width="65px" /></a></li>
        </ul>
      </div>
    </div>
  )
}

const Navigation = () => (
  <div className="navigation">
    <div className="navigation-inner">
      <ul>
        <li><a href="https://www.bsilab.com/">Home</a></li>
        <li><a href="https://www.bsilab.com/manufacturers/">Manufacturers</a></li>
        <li><a href="https://www.bsilab.com/promos/">Promos</a></li>
        <li><a href="https://www.bsilab.com/sales-team/">Sales Team</a></li>
        <li><a href="https://www.bsilab.com/blog/">Blog</a></li>
      </ul>
    </div>
  </div>
)

const Header = () => {
  return (
    <div
      className="bsi"
    >
      <Topbar />
      <div className="header-main">
        <div className="header-main-inner">
          <a href="https://bsilab.com">
            <img src="https://www.bsilab.com/wp-content/uploads/2021/03/cropped-BSI-Final-ESOP-Logo.png" />
          </a>
          <div className="orange-btn-ctn">
            <a className="orange-btn" href="https://wwww.bsilab.com/contact/">Request More Information</a>
            <a className="orange-btn" href="https://wwww.bsilab.com/blog/">Latest News</a>
          </div>
        </div>
      </div>
      <Navigation />
    </div>
  )
}

export default Header
